import L from 'leaflet';
import { Door as RmfDoor } from 'rmf-models';
import { fromRmfCoords, fromRmfYaw } from '../utils';
import { Box3, Vector3, Euler } from 'three';
export function viewBoxFromLeafletBounds(bounds) {
    var lbounds = bounds instanceof L.LatLngBounds ? bounds : new L.LatLngBounds(bounds);
    var width = lbounds.getEast() - lbounds.getWest();
    var height = lbounds.getNorth() - lbounds.getSouth();
    return "".concat(lbounds.getWest(), " ").concat(lbounds.getNorth(), " ").concat(width, " ").concat(height);
}
export function affineImageBounds(image, width, height) {
    // FIXME: This assumes that the origin is at the top left.
    // RMF does not provide enough information to determine the origin. We need at least 2
    // points to draw a rectangle, but RMF only provides x, y, width. height. Width and height
    // cannot find the end points because they are absolute values.
    return [
        [image.y_offset, image.x_offset],
        [-(height * image.scale + image.y_offset), width * image.scale + image.x_offset],
    ];
}
export function loadAffineImage(image) {
    var imageElement = new Image();
    var imageUrl = image.data;
    imageElement.src = imageUrl;
    return new Promise(function (res) {
        var listener = function () {
            imageElement.removeEventListener('load', listener);
            res(imageElement);
        };
        imageElement.addEventListener('load', listener);
    });
}
export function getRmfTransform(location) {
    var pos = fromRmfCoords([location.x, location.y]);
    var yaw = (fromRmfYaw(location.yaw) / Math.PI) * 180;
    return "translate(".concat(pos[0], " ").concat(pos[1], ") rotate(").concat(yaw, ")");
}
export function getDoorCenter(door) {
    var v1 = [door.v1_x, door.v1_y];
    var v2 = [door.v2_x, door.v2_y];
    switch (door.door_type) {
        case RmfDoor.DOOR_TYPE_SINGLE_SLIDING:
        case RmfDoor.DOOR_TYPE_SINGLE_SWING:
        case RmfDoor.DOOR_TYPE_SINGLE_TELESCOPE:
        case RmfDoor.DOOR_TYPE_DOUBLE_SLIDING:
        case RmfDoor.DOOR_TYPE_DOUBLE_SWING:
        case RmfDoor.DOOR_TYPE_DOUBLE_TELESCOPE:
            return [(v1[0] + v2[0]) / 2, (v2[1] + v1[1]) / 2];
        default:
            throw new Error('unknown door type');
    }
}
var distance = function (v1, v2) { return Math.hypot(v2.x - v1.x, v2.y - v1.y); };
var midPoint = function (v1, v2) { return [(v2.x + v1.x) / 2, (v2.y + v1.y) / 2]; };
export var graphToWalls = function (graph) {
    var walls = [];
    var edges = graph.edges, vertices = graph.vertices;
    edges.map(function (edge) {
        var v1 = vertices[edge.v1_idx];
        var v2 = vertices[edge.v2_idx];
        var depth = distance(v1, v2);
        var midpoint = midPoint(v1, v2);
        var width = 0.3;
        var height = 8;
        var position = midpoint.concat(height / 2 + 0);
        var angle = Math.atan2(v1.y - v2.y, v1.x - v2.x) - Math.PI / 2;
        var rot = new Euler(0, 0, angle);
        return walls.push({
            position: position,
            width: width,
            height: height,
            depth: depth,
            rot: rot,
        });
    });
    return walls;
};
export var findSceneBoundingBoxFromThreeFiber = function (level) {
    if (!level) {
        return;
    }
    var minX = Infinity;
    var minY = Infinity;
    var minZ = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    var maxZ = -Infinity;
    var walls = graphToWalls(level.wall_graph);
    walls.forEach(function (wall) {
        var _a = wall.position, x = _a[0], y = _a[1], z = _a[2];
        var width = wall.width;
        var height = wall.height;
        minX = Math.min(minX, x - width / 2);
        minY = Math.min(minY, y - width / 2);
        minZ = Math.min(minZ, z - height / 2);
        maxX = Math.max(maxX, x + width / 2);
        maxY = Math.max(maxY, y + width / 2);
        maxZ = Math.max(maxZ, z + height / 2);
    });
    return new Box3(new Vector3(minX, minY, minZ), new Vector3(maxX, maxY, maxZ));
};
